var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Burger_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Burger_svg__a",
    d: "M14 15v-1a3 3 0 00-3-3H6a3 3 0 00-3 3v1M12 21H5a2 2 0 01-2-2v-1h11v1a2 2 0 01-2 2zM2 15h13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Burger_svg__a",
    d: "M10.684 11L10.3 8.132A1 1 0 0111.3 7H20a1 1 0 01.99 1.141l-1.714 12a1 1 0 01-.99.859h-2.133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Burger_svg__a",
    d: "M19.153 3h-2.137a1 1 0 00-.989.853L15.559 7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgBurger;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Burger.svg
// module id = 828
// module chunks = 101